'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.router = undefined;

var _reactRouterRedux = require('react-router-redux');

var _reactRouter = require('react-router');

var router = exports.router = (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/middleware.js
 ** module id = 507
 ** module chunks = 0
 **/